export const sanitizePathname = (path: string): string => {
    if (!path || !path.startsWith('/') || path.startsWith('//')) {
        return '/';
    }

    return path;
};
